import { render, staticRenderFns } from "./PaymentDescription.vue?vue&type=template&id=697ce50a&scoped=true&"
import script from "./PaymentDescription.vue?vue&type=script&lang=ts&"
export * from "./PaymentDescription.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentDescription.vue?vue&type=style&index=0&id=697ce50a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697ce50a",
  null
  
)

export default component.exports